<template>
    <v-field :has-error="hasError" :error-label="errorLabel" :helper="helper">
        <q-select ref="field"
                  v-model="inputValue"
                  :clearable="clearable"
                  :filter="filter"
                  autofocus-filter
                  :filter-placeholder="`${$T('type to search')} (${itemsAvailable})`"
                  :name="path"
                  :float-label="processedLabel"
                  :options="filteredOptions"
                  :color="color"
                  :disable="form.busy || disable"
                  @termsChanged="(terms) => this.terms = terms"
                  @input="onInput"></q-select>
    </v-field>
</template>

<script>
    import mixins from './mixins'
    import Fuse from 'fuse.js'
    import {QSelect} from 'quasar-framework'

    // Add a watcher to QSelect component on "created" event. This watcher emits a "termsChanged" event when
    // the internal var "terms" changes allowing us to hook on that event and sync our local "terms" var
    QSelect.created = function () {
        this.$watch('terms', (newVal) => {
            this.$emit('termsChanged', newVal)
        })
    }

    export default {
        name: 'VAutocompleteList',

        mixins,

        props: {
            options: {
                type: Array,
                required: true
            },
            itemPlural: String,
            top: {
                type: Number,
                default: 20
            },
            autoSelect: Boolean,
            fuseConfig: {
                type: Object,
                default() {
                    return {
                        shouldSort: true,
                        tokenize: true,
                        findAllMatches: true,
                        threshold: 0.3,
                        location: 0,
                        distance: 3,
                        maxPatternLength: 32,
                        minMatchCharLength: 0,
                        keys: [
                            'label',
                            'sublabel'
                        ]
                    }
                }
            }
        },

        components: {
            QSelect
        },

        data() {
            return {
                inputValue: null,
                fuse: new Fuse(this.options, this.fuseConfig),
                terms: ''
            }
        },

        watch: {
            value(newValue) {
                if (this.options.find(o => o.value == newValue))
                    this.inputValue = newValue
                else
                    this.inputValue = null
            },
            options(newOptions) {
                this.fuse = new Fuse(newOptions, this.fuseConfig)
                this.selectOnlyOption()
            }
        },

        mounted() {
            if (this.options.find(o => o.value == this.value))
                this.inputValue = this.value

            this.selectOnlyOption()
        },

        computed: {
            filteredOptions() {
                var results = this.fuse.search(this.terms)
                if (results.length == 1) {
                    this.inputValue = results[0].value
                    this.onInput()
                    if (this.$refs.field) this.$refs.field.hide()
                }
                if (!this.terms) {
                    results = this.topOptions
                }

                if (this.$refs.field) this.$nextTick(() => this.$refs.field.reposition())
                return this.addSelectedTo(results)
            },

            topOptions() {
                return [{value: '#', label: this.$T('frequent options:'), disable: true}]
                    .concat(this.options.slice(0, this.top))
            },

            itemsAvailable() {
                var items = this.itemPlural ? this.itemPlural : this.$t('items')
                return `${this.options.length} ${items} ${this.$t('available_plural')}`
            }
        },

        methods: {
            filter: () => (true),

            addSelectedTo(options) {
                if (!options.find(opt => opt.value == this.value) && this.value){
                    if (this.options.find(opt => opt.value == this.value)) {
                        return [this.options.find(opt => opt.value == this.value)].concat(options)
                    }
                }
                return options
            },

            selectOnlyOption() {
                if (this.options.length != 1 || !this.autoSelect) return
                this.inputValue = this.options[0].value
                this.onInput()
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/form/VAutocompleteList.vue